import { useState, useEffect, useCallback } from 'react';

const WEATHER_API_KEY = 'd03faf24aedbdb7d76282c2b9be02e08';
//todo 56b2266f0620e9e6bf69b5bb6b7a0feb

export const useWeather = (coordinates) => {
  const [weatherData, setWeatherData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const getWeatherDataJSONP = useCallback((lat, lng) => {
    return new Promise((resolve, reject) => {
      if (!lat || !lng || isNaN(lat) || isNaN(lng)) {
        reject(new Error('Неверные координаты'));
        return;
      }

      const callbackName = 'weatherCallback_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
      const script = document.createElement('script');

      let timeoutId;

      const cleanup = () => {
        if (timeoutId) clearTimeout(timeoutId);
        if (window[callbackName]) delete window[callbackName];
        if (script.parentNode) document.head.removeChild(script);
      };

      timeoutId = setTimeout(() => {
        cleanup();
        reject(new Error());
      }, 10000);

      window[callbackName] = (data) => {
        cleanup();

        if (data && data.cod === 200) {
          resolve({
            temperature: Math.round(data.main.temp),
            pressure: Math.round(data.main.pressure * 0.75),
            humidity: data.main.humidity,
            description: data.weather[0].description,
            icon: data.weather[0].icon,
            feelsLike: Math.round(data.main.feels_like),
            windSpeed: data.wind.speed,
            timestamp: new Date().toISOString()
          });
        } else {
          reject(new Error(data?.message || 'Данные о погоде недоступны'));
        }
      };

      script.onerror = () => {
        cleanup();
        reject(new Error('Ошибка сети'));
      };

      script.src = `https://api.openweathermap.org/data/2.5/weather?lat=${lat}&lon=${lng}&appid=${WEATHER_API_KEY}&units=metric&lang=ru&callback=${callbackName}`;
      document.head.appendChild(script);
    });
  }, []);

  const loadWeather = useCallback(async () => {
    if (!coordinates?.lat || !coordinates?.lng ||
      isNaN(coordinates.lat) || isNaN(coordinates.lng)) {
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const weather = await getWeatherDataJSONP(coordinates.lat, coordinates.lng);
      setWeatherData(weather);
    } catch (err) {
      setError(err.message);
      console.error('Ошибка загрузки погоды:', err);
    } finally {
      setLoading(false);
    }
  }, [coordinates, getWeatherDataJSONP]);

  useEffect(() => {
    if (coordinates?.lat && coordinates?.lng) {
      loadWeather().then();
    }
  }, [coordinates?.lat, coordinates?.lng, loadWeather]);

  const refreshWeather = useCallback(() => {
    loadWeather().then();
  }, [loadWeather]);

  return {
    weatherData,
    loading,
    error,
    refreshWeather
  };
};
